import { useEffect } from "react";
import { CustomDropdown } from "../../../../component/customdropdown/CustomDropdown";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import classes from "./bulkSpareLotListFilterPage.module.css";

import { toast } from "react-toastify";
// import axiosInstance from "../../../../axios/axiosTokenMiddleware";
import {
  selectBulkSparesLotFilterState,
  setBulkSparesLotFilter,
} from "../../../../store/bulk/bulkSparesLotFilterSlice";

// const uploadUrl =
//   "https://dev.backend.mobigarage.com/v1/mp/sellers/bulk_deals/spares/upload_file";

// export const uploadImageRequest = async (file) => {
//   const formData = new FormData();
//   formData.append("uploaded_file", file);

//   try {
//     const response = await axiosInstance.post(uploadUrl, formData);

//     return {
//       success: true,
//       code: response.data.code, // very important
//       data: response.data.data || [],
//       message: response.data.message?.displayMessage,
//     };
//   } catch (error) {
//     return {
//       success: false,
//       error: error.response?.data?.message?.displayMessage || "Upload failed",
//     };
//   }
// };

const statuses = [];
const sellerList = [];

export const BulkSpareLotListFilterPage = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = useSelector(selectBulkSparesLotFilterState);

  // const [uploadBulkFile, { isLoading }] = useUploadBulkSpareFileMutation();

  /* ---------- Sync URL → Redux ---------- */
  useEffect(() => {
    const seller_id = searchParams.get("seller_id") || "";
    const status = searchParams.get("status") || "";

    if (seller_id !== filters.seller_id || status !== filters.status) {
      dispatch(setBulkSparesLotFilter({ seller_id, status }));
    }
  }, [searchParams, filters, dispatch]);

  /* ---------- Update URL ---------- */
  const updateFilterParams = (key, value) => {
    const params = new URLSearchParams(searchParams);

    value ? params.set(key, value) : params.delete(key);

    setSearchParams(params);
  };

  const handleSelection = (key, value) => {
    updateFilterParams(key, value);
  };

  // const handleFileChange = async (event) => {
  //   const selectedFile = event.target.files[0];
  //   if (!selectedFile) return;

  //   const toastId = toast.loading("Uploading...");

  //   const result = await uploadImageRequest(selectedFile);

  //   // ❌ TRUE ERROR → current flow unchanged
  //   if (!result.success) {
  //     toast.update(toastId, {
  //       render: result.error,
  //       type: "error",
  //       isLoading: false,
  //       autoClose: 2000,
  //     });

  //     return;
  //   }

  //   // ✔️ FORMAT CORRECT → KEEP SAME FLOW
  //   if (result.code !== "414") {
  //     toast.update(toastId, {
  //       render: "File uploaded successfully!",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 2000,
  //     });
  //   }

  //   // ⚠️ FORMAT WRONG → SHOW WARNING + TABLE
  //   else {
  //     toast.update(toastId, {
  //       render: result.message || "Some rows failed to process",
  //       type: "warning",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }

  //   event.target.value = null;
  // };

  // const handleDownload = () => {
  //   const link = document.createElement("a");

  //   link.href =
  //     "https://aws-mg-new-bucket.s3.ap-south-1.amazonaws.com/mg_template_bulk_spares_file.xlsx";

  //   link.setAttribute("download", "mg_template_bulk_spares_file.xlsx");

  //   document.body.appendChild(link);

  //   link.click();

  //   document.body.removeChild(link);
  // };

  return (
    <div className={classes.box}>
      {/* Hidden input */}

      <div className={classes.box__content}>
        <CustomDropdown
          id="seller_id"
          label="Select Seller"
          options={sellerList}
          selectedId={Number(filters.seller_id) || ""}
          onSelection={handleSelection}
        />
      </div>

      <div className={classes.box__content}>
        <CustomDropdown
          id="status"
          label="Select Status"
          options={statuses}
          selectedId={filters.status || ""}
          onSelection={handleSelection}
        />
      </div>

      {/* <div className={classes.actions}>
       
        <input
          id="bulk-upload-input"
          type="file"
          hidden
          accept=".xlsx,.xls,.csv"
          onChange={handleFileChange}
          disabled={isLoading}
        />
        <label
          htmlFor="bulk-upload-input"
          className={classes.actionBtn}
          style={{
            pointerEvents: isLoading ? "none" : "auto",
            opacity: isLoading ? 0.6 : 1,
          }}
        >
          <ArrowUpTrayIcon className={classes.icon} />
          <span>{isLoading ? "Uploading..." : "Upload File"}</span>
        </label>

       
        <button className={classes.actionBtn} onClick={handleDownload}>
          <ArrowDownTrayIcon className={classes.icon} />
          <span>Download Template</span>
        </button>
      </div> */}
    </div>
  );
};
